/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, Button, Stack, Typography } from "@mui/material";
import { serviceworldHeroStyle } from "@/src/components/Sections/Generic/ServiceworldHero/serviceworldHeroStyle";
import Container from "@/src/components/Container/Container";
import { useAuthDialog } from "@/src/provider/AuthDialog/AuthDialogProvider";
import { useTheme } from "@mui/material/styles";
import Section from "@/src/components/Section/Section";
import desktopImage from "@/src/assets/img/serviceworldHero/desktop.png";
import mobileImage from "@/src/assets/img/serviceworldHero/mobile.png";

export default function ServiceworldHero() {
  const { setView } = useAuthDialog();
  const theme = useTheme();

  return (
    <Section sx={serviceworldHeroStyle.serviceworldHero}>
      <Container variant={"xs"}>
        <Typography variant={"h1"} align={"center"} sx={{ marginBottom: "1.5rem" }}>
          Recht leicht gemacht
        </Typography>
        <Typography
          align={"center"}
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            marginBottom: "2rem",
          })}
        >
          Rechtliche Sicherheit, wenn Sie sie brauchen!
          <br /> Unser Fokus: Ihr persönlicher Erfolg. Unser Fundament: Langjährige Erfahrung. Unser Vorteil: Neueste Technologie.
        </Typography>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={"1rem"}
          sx={{ width: { xs: "100%", sm: "auto" }, marginBottom: "1.5rem", justifyContent: "center" }}
        >
          <Button variant={"contained"} onClick={() => setView({ type: "login" })} sx={{ minWidth: { xs: "auto", sm: "12rem" } }}>
            Anmelden
          </Button>
          <Button variant={"outlined"} onClick={() => setView({ type: "register" })} sx={{ minWidth: { xs: "auto", sm: "12rem" } }}>
            Registrieren
          </Button>
        </Stack>
      </Container>
      <picture>
        <source media={`(min-width: ${theme.breakpoints.values.sm}px)`} srcSet={desktopImage} width={1589} height={802} />
        <Box component={"img"} src={mobileImage} alt={""} sx={serviceworldHeroStyle.image} width={478} height={1031} fetchPriority="high" />
      </picture>
    </Section>
  );
}
